// extracted by mini-css-extract-plugin
export default {"Trigger":"_Trigger--C5xJv","Active":"_Active--adO_I","MenuItem":"_MenuItem--wk4_S"};